<template>
  <search-group
    @search="findData"
    @clear="clearValue"
    :span="24"
    :btnOffset="18"
    :btnSpan="6"
    :inline="true"
    style="padding-left: 20px;padding-top: 5px"
  >
    <Row class="mb16" :gutter="36">
      <Col span="6" class="max64">
        <div>
          <Select v-model="searchData.projectFid" placeholder="项目名称" multiple>
            <Option value @click.native="allSelect">全部选择</Option>
            <Option
              v-for="(item,index) in projectList"
              :key="'s1'+index"
              :value="item.value||0"
            >{{item.text}}</Option>
          </Select>
          <span class="count">{{searchData.projectFid.length}}</span>
        </div>
      </Col>
      <Col span="12">
        <Button
          size="small"
          :type="type==='now'?'primary':'default'"
          @click.stop="changeType('now')"
        >本月</Button>
        <Button
          size="small"
          :type="type==='before'?'primary':'default'"
          @click.stop="changeType('before')"
          style="margin-right: 10px"
        >按月</Button>
        <DatePicker
          v-show="type==='now'"
          style="width: 200px;"
          v-model="searchData.initTimes"
          :options="startdateoptions"
          split-panels
          type="daterange"
          format="yyyy-MM-dd"
        ></DatePicker>

        <DatePicker
          v-show="type==='before'"
          v-model="searchData.startMonth"
          type="month"
          :options="startoptions"
          format="yyyy-MM"
          placeholder="请选择起始月"
        ></DatePicker>

        <DatePicker
          v-show="type==='before'"
          v-model="searchData.endMonth"
          type="month"
          :options="endoptions"
          format="yyyy-MM"
          placeholder="请选择结束月"
        ></DatePicker>
      </Col>
    </Row>
  </search-group>
</template>

<script>
// import SearchGroup from "components/SearchGroup/index";
import { mapGetters } from "vuex";
import { formatDateTime, deepClone } from "@/utils/format";
import {getProjects} from "../../../../api/common";

export default {
  components: {
    // SearchGroup
  },
  data() {
    return {
      projectList:[],
      type: "now",
      searchData: {
        projectFid: [],
        initTimes: ["", ""],
        startMonth: new Date(new Date().setMonth(new Date().getMonth()-1,1)),
        endMonth: new Date(new Date().setMonth(new Date().getMonth(),0))
      }
    };
  },
  computed: {
    // ...mapGetters(["projectList"]),
    startoptions() {
      const that = this;
      return {
        disabledDate(date) {
          return that.searchData && that.searchData.endMonth
            ? date.valueOf() > that.searchData.endMonth.valueOf()
            : false;
        }
      };
    },
    endoptions() {
      const that = this;

      return {
        disabledDate(date) {
          const now = new Date();
          return that.searchData && that.searchData.startMonth
            ? date.valueOf() < that.searchData.startMonth.valueOf() ||
                date.valueOf() > now.setMonth("0" + now.getMonth(), 0)
            : false;
        }
      };
    },
    startdateoptions() {
      const that = this;
      const startDate = this.preMonthLastDay();
      const startDateTime = new Date(startDate);
      return {
        disabledDate(date) {
          const now = new Date();
          now.setDate(now.getDate() - 1);
          return  date.valueOf() < startDateTime.valueOf() ||
                  date.valueOf() > now.valueOf();

        }
      };
    },
      searchDataParams() {
      function f(data) {
        return data ? formatDateTime(data, false) : "";
      }

      return {
        current: this.type,
        endTime:
          this.type === "now"
            ? f(this.searchData.initTimes[1])
            : this.searchData.endMonth
            ? f(
                new Date(
                  this.searchData.endMonth.setMonth(
                    this.searchData.endMonth.getMonth() + 1,
                    0
                  )
                )
              )
            : null,
        projectFids: this.searchData.projectFid,
        startTime:
          this.type === "now"
            ? f(this.searchData.initTimes[0])
            : this.searchData.startMonth
            ? f(this.searchData.startMonth)
            : null
      };
    }
  },
  // watch: {
  //   projectList(projectList) {
  //     // if(!projectList || projectList[0] == '') return;
  //     let projectLists = [];
  //     projectList.forEach((project, index) => {
  //       if (project.value) {
  //         //去除上海七星宝&深圳龙华
  //         let noChoose=[
  //           "2c908d194f5f09b8014f62b8a9ab00241",
  //           "8a908f0767ef44be0168195d2c3600d8",
  //           "2c908d194f5f09b8014f62b8a9ab0024",
  //           "8a908f0767ef44be0168195d2c3600d8" ,
  //           "2c908d194f5f09b8014f62b8a9ab0024",
  //           "8a908f0767ef44be0168195d2c3600d8"
  //         ]
  //         if(!noChoose.includes(project.value)){
  //         projectLists.push(project.value);
  //       }
  //
  //       }
  //     });
  //     this.searchData.projectFid = projectLists;
  //     this.$emit("searchParams", this.searchDataParams);
  //
  //   }
  // },

  created() {
    const date = new Date(new Date().getTime() - 86400000);
    this.searchData.initTimes = [
      new Date(date.getFullYear(), date.getMonth(), 1),
      date
    ];

  },
  mounted() {


    getProjects().then(res => {
      if(!res.data){
        return
      }
      this.projectList = res.data
      const projectLists = [];
      this.projectList.forEach((project, index) => {
        if (project.value) {
          //去除上海七星宝&深圳龙华
          const noChoose=[
            "2c908d194f5f09b8014f62b8a9ab00241",
            "8a908f0767ef44be0168195d2c3600d8",
            "2c908d194f5f09b8014f62b8a9ab0024",
            "8a908f0767ef44be0168195d2c3600d8" ,
            "2c908d194f5f09b8014f62b8a9ab0024",
            "8a908f0767ef44be0168195d2c3600d8"
          ]

          if(!noChoose.includes(project.value)){
            if(project.isSelect === 1){
              projectLists.push(project.value)
            }
            // projectLists.push(project.value);
          }

        }
      });
      this.searchData.projectFid = projectLists;



    }).catch(error => {
    }).finally(()=>{
      this.$emit("searchParams", this.searchDataParams);

    })


    // this.allSelect();
    // this.$emit("searchParams", this.searchDataParams);

  },
  methods: {
    changeType(value) {
      this.type = value;
    },
    allSelect() {
      if (this.searchData.projectFid.length > 1) {
        this.searchData.projectFid = [];
      } else {
        const projectLists = [];
         Array.from(this.projectList).map((project, index) => {
          if (project.value) {
            //去除上海七星宝&深圳龙华
            const noChoose=[
              "2c908d194f5f09b8014f62b8a9ab00241",
              "8a908f0767ef44be0168195d2c3600d8",
              "2c908d194f5f09b8014f62b8a9ab0024",
              "8a908f0767ef44be0168195d2c3600d8" ,
              "2c908d194f5f09b8014f62b8a9ab0024",
              "8a908f0767ef44be0168195d2c3600d8"
            ]
            if(!noChoose.includes(project.value)){
              projectLists.push(project.value);
            }
            // projectLists.push(project.value);
          }
        });
        this.searchData.projectFid = projectLists;
      }
    },
    findData() {
      if (this.searchDataParams.projectFids.length == 0) {
        this.$Message.info("所选项目为空");
        return false;
      }
      this.$emit("searchParams", this.searchDataParams);
    },
    clearValue() {
      this.searchData = {
        projectFid: [],
        initTimes: ["", ""],
        startMonth: "",
        endMonth: ""
      };
      const date = new Date();
      this.searchData.initTimes = [
        new Date(date.getFullYear(), date.getMonth(), 1),
        date
      ];
    },
    /*获取上个月的最后一天,如果是本月第一天，则取上上个月的最后一天*/
    preMonthLastDay(){
      const nowdays = new Date();
      let year = nowdays.getFullYear();
      let month = nowdays.getMonth();
      if(month==0){
        month = 12;
        year = year-1;
      }
      //如果是每月第一天，则再减一个月
      if(nowdays.getDate() == 1){
        month = month -1;
        if(month==0){
          month = 12;
          year = year-1;
        }
      }
      if(month<10){
        month = '0'+month;
      }
      const myDate = new Date(year,month,0);
      const startDate = year+'-'+month+'-'+myDate.getDate()+' 23:59:00';//上个月最后一天
      return startDate;
    }

  }
};
</script>

<style scoped>
.count {
  display: inline-block;
  min-width: 16px;
  min-height: 16px;
  position: absolute;
  top: -10px;
  left: 13px;
  background: #cfa868;
  color: #ffffff;
  border-radius: 100%;
  line-height: 15px;
  text-align: center;
  font-weight: 600;
}
</style>
